export default "<span>({{getTime()}})</span>\r\n";